export const once = (func) => {
    let alreadyCalled = false

    return (...args) => {
        if (!alreadyCalled) {
            func(...args)
            alreadyCalled = true
        }
    }
}

export function debounce (func, wait) {
  let timeout

  return (...args) => {
    clearTimeout(timeout)
    timeout = setTimeout(() => func(...args), wait)
  }
}
